export default {
  state: {
    airports: [],
    nearByAirports: {
      pickup: [],
      dropoff: [],
      international: {}
    }
  },
  mutations: {
    setAirportData (state, data) {
      for (let field in data) {
        state[field] = data[field]
      }
    },
    setNearyByAirports (state, data) {
      for (let field in data) {
        state.nearByAirports[field] = data[field]
      }
    },
    setInternationalAirport (state, data) {
      state.nearByAirports.international[data.location] = data.code
      // for (let field in data) {
        // state.nearByAirports.international[field] = data[field]
      // }
    },
    addNearyByAirports (state, data) {
      state.nearByAirports[data.field].push(data.val)
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/booking/airports.js